import { render, staticRenderFns } from "./admin-notification-container.vue?vue&type=template&id=5a64ad48&scoped=true&lang=pug"
import script from "./admin-notification-container.js?vue&type=script&lang=js&external"
export * from "./admin-notification-container.js?vue&type=script&lang=js&external"
import style0 from "./admin-notification-container.vue?vue&type=style&index=0&id=5a64ad48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64ad48",
  null
  
)

export default component.exports